import { useLocation } from 'react-router-dom';

import t from '../../../text';
import starWhite from '../../assets/images/white-star.svg';

const PREVIOUS_BOOKING_JOURNEY = ['/my-booking', '/login'];

export const HeaderBar = ({ openMyBookingModal }) => {
  const location = useLocation();
  const isInBookingJourney = location.pathname.includes('/booking/');

  const isInPreviousBookingJourney = PREVIOUS_BOOKING_JOURNEY.includes(location.pathname);

  return (
    <div className="header-bar bg-primary border-bottom p-2 pl-4 d-flex justify-content-between w-100">
      {!isInBookingJourney && !isInPreviousBookingJourney && (
        <button onClick={openMyBookingModal} className="remove-button-styling text-white cursor-pointer mr-3">
          <i className="icon-sign-in" /> {t('header.myBooking')}
        </button>
      )}

      <div className="d-flex ml-auto">
        {(isInBookingJourney || isInPreviousBookingJourney) && (
          <a href={`tel:${t('header.cs.tel')}`} className="text-white">
            <i className="icon-phone" /> {t('header.cs.tel')}
          </a>
        )}

        <a
          href="https://uk.trustpilot.com/review/www.breakfreeholidays.co.uk?stars=5"
          target="_blank"
          rel="noopener noreferrer"
          className="d-none d-md-flex ml-4 text-white"
        >
          See our reviews on <img src={starWhite} alt="Trustpilot star" width="22px" className="mx-1 mb-1" /> Trustpilot
        </a>
      </div>
    </div>
  );
};
